import * as React from "react"
import {useEffect} from "react"

import {HOME_ROUTES, BANNERS_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {isSystemBusy,} from "@signals";
import {resetTopBannersSignals, topBannersIsEmpty, topBannersHasLimit} from "./@signals";
import TopBannersFilters from "./Filters";
import TopBannersTable from "./Table";


export default function TopBannersPage() {

    useEffect(() => {
        return () => resetTopBannersSignals()
    }, []);

    const LIMIT_SEARCHES = [{
        title: "Over 1000 results found",
        message: 'You can download the Excel file to view all results, but please be aware that it may take some time to generate the Excel file.',
        severity: 'warning'
    }]

    return <PageWrapper
        head={`DIP Insight | ${BANNERS_ROUTES.TOP_BANNERS_TITLE}`}
        title={BANNERS_ROUTES.TOP_BANNERS_TITLE}
        subtitle={BANNERS_ROUTES.TOP_BANNERS_SUBTITLE}
        filters={<TopBannersFilters />}
        isEmpty={topBannersIsEmpty.value}
        hasErrors={isSystemBusy.value}
        globalMessages={topBannersHasLimit.value && LIMIT_SEARCHES}
    >
        <TopBannersTable />
    </PageWrapper>
}